import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GetToken, getRole } from "../constant/default";
import { useSelector } from "react-redux";
import { auth_details } from "../reducer/auth";
import { Capacitor } from '@capacitor/core';

export const PrivateRoute = ({ children, props }) => {
  const userDetail = useSelector(auth_details);
  const location = useLocation();

  // Check if we came from a notification
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const fromNotification = localStorage.getItem('from_notification') === 'true';
      const threadId = localStorage.getItem('notification_threadId');
      
      // If we're on the chat route and came from a notification, log it
      if (fromNotification && location.pathname.includes('/chat')) {
        console.log('🔔 Navigation to chat from notification complete:', location.pathname);
        console.log('🔔 ThreadId from notification:', threadId);
        
        // Clear the notification flag after successfully navigating 
        // but keep threadId as it may be needed by the chat component
        localStorage.removeItem('from_notification');
      }
    }
  }, [location]);

  let role;
  if(getRole() === "User") {
    role = "user";
  } else if(getRole() === "ServiceProvider") {
    role = "consultant";
  }
  
  // Check if we need to handle notification navigation
  const fromNotification = Capacitor.isNativePlatform() && 
                         localStorage.getItem('from_notification') === 'true';
  
  if (GetToken() && userDetail?.login?.isSuccess) {
    // User is authenticated
    if (getRole() === props?.role) {
      // User has the correct role for this route
      
      // If we came from a notification and are trying to access the wrong chat route, 
      // redirect to the correct chat route
      if (fromNotification && 
          ((props?.role === 'User' && location.pathname !== '/user/chat') ||
           (props?.role === 'ServiceProvider' && location.pathname !== '/consultant/chat'))) {
        
        const chatRoute = props?.role === 'User' ? '/user/chat' : '/consultant/chat';
        console.log(`🔄 Redirecting notification navigation to correct chat route: ${chatRoute}`);
        return <Navigate to={chatRoute} />;
      }
      
      return <>{children}</>;
    } else {
      // User has the wrong role for this route - redirect to their home page
      return <Navigate to={`/${role}/home`} />;
    }
  } else {
    // User is not authenticated - redirect to login
    return <Navigate to={`/`} />;
  }
};

export const RedirectRoute = ({ children }) => {
  const userDetail = useSelector(auth_details);

  let role;
  if (getRole() === 'User') {
    role = 'user';
  } else if (getRole() === 'ServiceProvider') {
    role = 'consultant';
  }

  const isAuthenticated = GetToken() && userDetail?.login?.isSuccess;

  // Handle notification-based navigation on initial authentication
  if (isAuthenticated && Capacitor.isNativePlatform()) {
    const fromNotification = localStorage.getItem('from_notification') === 'true';
    
    if (fromNotification) {
      // If we're already authenticated and came from a notification, go straight to chat
      const chatRoute = role === 'user' ? '/user/chat' : '/consultant/chat';
      console.log(`🔄 Authenticated user coming from notification - redirecting to ${chatRoute}`);
      return <Navigate to={chatRoute} />;
    }
  }

  if (isAuthenticated) {
    return <Navigate to={`/${role}/home`} />;
  } else {
    return children;
  }
};